/* DB Professional - aggancio checkout per app dati fiscali (GetFiscal)
   global.js ricostruisce il carrello con innerHTML a ogni modifica, quindi
   qualunque cosa un'app inietti dentro [data-cart-lines] viene cancellata.
   Questo script sposta il pulsante di pagamento FUORI da quel contenitore e
   lo trasforma nel form carrello standard Shopify (<form action="/cart"
   method="post"> + <button name="checkout">), che e' la struttura che le app
   di raccolta dati fiscali cercano per agganciarsi e bloccare il checkout. */
(function () {
  'use strict';

  var CLS = 'dbp-checkout';
  var I18N = window.DBP_I18N || {};
  var dec = function (s) { var x = document.createElement('textarea'); x.innerHTML = s; return x.value; };
  var T = function (k, fb) { return (I18N[k] != null && I18N[k] !== '') ? dec(I18N[k]) : fb; };
  var NOTE = T('fiscal_note', 'Pagamento protetto con carta, PayPal o bonifico. Fattura sempre inclusa: servono codice fiscale (privati) o partita IVA (aziende).');

  function build(box) {
    var host = box.parentNode;
    if (!host) return null;
    var form = host.querySelector(':scope > .' + CLS);
    if (form) return form;
    form = document.createElement('form');
    form.className = CLS + ' checkout';
    form.setAttribute('action', '/cart');
    form.setAttribute('method', 'post');
    form.setAttribute('novalidate', 'novalidate');
    form.hidden = true;
    form.innerHTML =
      '<div data-fiscal-slot></div>' +
      '<button type="submit" name="checkout" class="btn btn--accent" data-checkout-btn>' + T('checkout', 'Vai al pagamento') + '</button>' +
      '<div style="font-size:13px;color:#6f6c58">' + NOTE + '</div>';
    host.insertBefore(form, box.nextSibling);
    return form;
  }

  function sync(box) {
    var form = build(box);
    if (!form) return;
    var gen = box.querySelector('.checkout');
    var btn = form.querySelector('[data-checkout-btn]');
    if (gen) {
      var a = gen.querySelector('a');
      if (a && btn) btn.textContent = a.textContent.trim();
      gen.parentNode.removeChild(gen);
      form.hidden = false;
      return;
    }
    if (!box.querySelector('.line')) form.hidden = true;
  }

  function init() {
    var boxes = Array.prototype.slice.call(document.querySelectorAll('[data-cart-lines]'));
    boxes.forEach(function (box) {
      sync(box);
      if (!window.MutationObserver) return;
      new MutationObserver(function () { sync(box); }).observe(box, { childList: true });
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
